// Simple price-range estimator per category.
// All values in USD. Final price always confirmed via WhatsApp/email.
//
// Range = base × sizeMultiplier; glossy adds +20% on the high end of the range.

const SIZE_MULTIPLIERS = {
  P: 1, // Small (~5 cm)
  M: 1.9, // Medium (~10 cm)
  G: 3.2, // Large (~15–20 cm)
};

const FINISH_BUMP = {
  matte: { lo: 1.0, hi: 1.0 },
  glossy: { lo: 1.05, hi: 1.2 },
};

// Base [low, high] in USD per category at size P (smallest tier).
const CATEGORY_BASE = {
  people: [35, 55],
  animals: [30, 50],
  kids_cartoon: [35, 55],
  action_figures: [40, 70],
  keychains: [8, 15],
  home_objects: [25, 45],
  household: [15, 30],
  word_art: [20, 40],
  custom_specific: [40, 70],
  mothers_day: [35, 60],
  in_stock: [10, 30], // ready-made pieces in stock
};

export const SIZE_OPTIONS = ["P", "M", "G"];
export const FINISH_OPTIONS = ["matte", "glossy"];

export function estimatePrice(categoryKey, size, finish) {
  const base = CATEGORY_BASE[categoryKey];
  const sizeMul = SIZE_MULTIPLIERS[size];
  const bump = FINISH_BUMP[finish];
  if (!base || !sizeMul || !bump) return null;
  const lo = Math.round(base[0] * sizeMul * bump.lo);
  const hi = Math.round(base[1] * sizeMul * bump.hi);
  return { lo, hi };
}
